import React from 'react'
import styled from 'styled-components'
import { Exam } from 'types/exams'
import ExamButton from 'modules/exams/components/ExamButton'
import { EXAM_STATUS } from 'utils/exam'
import * as R from 'ramda'
import { useSelector } from 'react-redux'
import { getIsImpersonate, getStudent } from 'modules/auth/ducks/selectors'
import { formatMinutesToHoursAndMinutes } from 'utils/date'
import { useTranslation } from 'react-i18next'
export const FreeTrialFeaturedExamTile = ({ exam }: { exam: Exam }) => {
  const { t } = useTranslation()
  // @ts-ignore
  const isImpersonate: boolean = useSelector(getIsImpersonate)
  const status: string = R.propOr(EXAM_STATUS.scheduled, 'status', exam)
  const id: string = R.propOr('', 'id', exam)
  const examLength: number = R.pathOr(
    0,
    ['exam_length', 'summary', 'minutes'],
    exam
  )

  return (
    <Container>
      <Description>
        <TileHeader>
          <ExamTitle>{exam.title}</ExamTitle>
          <ExamIncludedInFreeTrial>
            {t('dashboard.freeTrial.featuredExams.label')}
          </ExamIncludedInFreeTrial>
        </TileHeader>
        <ExamDuration>
          {formatMinutesToHoursAndMinutes(examLength)}
        </ExamDuration>
      </Description>
      <ButtonContainer>
        <ExamButton
          id={id}
          isImpersonated={isImpersonate}
          status={status}
          exam={exam}
        />
      </ButtonContainer>
    </Container>
  )
}

const Container = styled.div`
  background: ${props => props.theme.colors.backgrounds.main};
  border-radius: 4px;
  box-shadow: 0px 2px 8px 0px #0000001a;
  border-left: 6px solid ${props => props.theme.colors.main.primary500};
  padding: 8px;
  display: flex;
  justify-content: space-between;
  gap: 4px;
`

const Description = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`

const TileHeader = styled.div`
  display: flex;
  gap: 4px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

const ExamTitle = styled.div`
  font-weight: 700;
  font-size: 16px;
  max-width: 211px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const ExamIncludedInFreeTrial = styled.div`
  font-weight: 400;
  font-size: 11px;
  color: ${props => props.theme.colors.main.grey700};
`

const ExamDuration = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: ${props => props.theme.colors.main.grey700};
`

const ButtonContainer = styled.div``
